module.exports = __webpack_public_path__ + "img/events-icon.3f135d15.svg";